import { EmbedderInfo } from '@worknet/models';

const qs = new URLSearchParams(location.search);

export const getAllQueryValues = () => {
  return Object.fromEntries(qs.entries());
};

export const getHeaders = () => {
  const widgetKey = qs.get('widgetKey');
  return {
    ...(widgetKey ? { 'x-wn-widget-key': widgetKey } : {}),
  };
};

export const getJwtToken = () => {
  return qs.get('jwt') || undefined;
};

export const getJwtHeaders = () => {
  const widgetKey = qs.get('widgetKey');
  const jwt = qs.get('jwt');
  return {
    ...(widgetKey ? { 'x-wn-widget-key': widgetKey } : {}),
    ...(jwt ? { 'x-wn-jwt': jwt } : {}),
  };
};

export const getCustomContext = () => {
  const customContext = qs.get('customContext');
  return customContext ? JSON.parse(customContext) : undefined;
};

export const getEmbedderInfo = () => {
  const embedderInfo = qs.get('embedderInfo');
  return embedderInfo ? (JSON.parse(embedderInfo) as EmbedderInfo) : undefined;
};

export const getGroupingId = () => {
  const groupingId = qs.get('groupingId');
  return groupingId || undefined;
};

export const getNudge = () => {
  const nudge = qs.get('nudge') === 'true';
  const input = qs.get('nudgeInput') || undefined;
  const display = qs.get('nudgeDisplay') || undefined;
  const nudgeId = qs.get('nudgeId') || undefined;
  return nudge ? { input, display, nudgeId } : undefined;
};

export const getInitialMessage = () => {
  return qs.get('initialMessage') || undefined;
};

export const getLinkTarget = () => {
  return qs.get('linkTarget') || undefined;
};
